module.exports = __webpack_public_path__ + "static/media/icon-award-02.1ae9d6d6.svg";